export function trackEvent(eventId, eventData) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventId,
    ...eventData
  });
}


// WEBPACK FOOTER //
// ./src/app/admin/services/tracking/GtmTracking.js